import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ClinicianHeader from '../../../components/DailyPlanning/ClinicianHeader/ClinicianHeader';
import { selectClinicianOnMap, downloadPlan } from '../../../actions/areas/dailyPlanning';
import { selectSchedulerMapView, selectJwtToken, selectPostcodeDistance } from '../../../reducers/areas/dailyPlanning';

const filteredDataSelector = createSelector(
  selectSchedulerMapView,
  selectJwtToken,
  selectPostcodeDistance,
  (schedulerMapView, jwtToken, postcodeDistance) => ({
    mapViewState: schedulerMapView.mapViewState,
    jwtToken,
    selectedClinicianId: schedulerMapView.selectedClinicianId,
    postcodeDistance,
  }),
);

const mapStateToProps = state => {
  const data = filteredDataSelector(state);
  return data;
};

const mapDispatchToProps = dispatch => ({
  selectClinician: clinicianId => dispatch(selectClinicianOnMap(clinicianId)),
  downloadPlan: (clinicianId, date, jwtToken, name) => dispatch(downloadPlan(clinicianId, date, jwtToken, name)),
});

const ClinicianHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false },
)(ClinicianHeader);

export default ClinicianHeaderContainer;
